import {Injectable} from '@angular/core';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {AnyObject} from '@shared/interfaces/objects.interface';

@Injectable({
  providedIn: 'root'
})
export class RouterService {
  constructor(
    protected route: ActivatedRoute,
    protected router: Router
  ) {}

  // tslint:disable-next-line:max-line-length
  changeQueryParams(
    queryParams: AnyObject,
    replaceUrl: boolean = true,
    extras: NavigationExtras = {},
    afterNavigateFn: (onfulfilled: boolean) => void = () => {},
  ): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl,
      ...extras
    }).then(onfulfilled => afterNavigateFn(onfulfilled));
  }

  isActiveRoute(link: string, exact: boolean = false): boolean {
    const currentUrl: string = new URL(this.router.url, location.origin).pathname;

    return exact
      ? currentUrl === link
      : currentUrl.includes(link);
  }
}
